// Shared date helpers. Date-only strings ("2026-10-26") are calendar days, so
// they are read as local midnight. `new Date("2026-10-26")` reads them as UTC,
// which shows the day before anywhere west of Greenwich (the Outreach bug).

const DAY_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

export function parseDay(v) {
  if (v == null || v === '') return null;
  if (v instanceof Date) return Number.isNaN(v.getTime()) ? null : v;
  const s = String(v).trim();
  const m = DAY_ONLY.exec(s);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function localToday(now = new Date()) {
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

/** "Oct 26", or "Oct 26, 2025" when it isn't this year (or `year: true`). */
export function fmtDay(v, { year, now = new Date(), empty = '' } = {}) {
  const d = parseDay(v);
  if (!d) return empty;
  const showYear = year === true || (year !== false && d.getFullYear() !== now.getFullYear());
  return d.toLocaleDateString('en-CA', showYear
    ? { month: 'short', day: 'numeric', year: 'numeric' }
    : { month: 'short', day: 'numeric' });
}

/** "Oct 26, 2:30 p.m." (year added when it isn't this year). */
export function fmtDateTime(v, { now = new Date(), empty = '' } = {}) {
  const d = parseDay(v);
  if (!d) return empty;
  const opts = { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' };
  if (d.getFullYear() !== now.getFullYear()) opts.year = 'numeric';
  return d.toLocaleString('en-CA', opts);
}

/** Whole days from today to v (negative = past). null when unparseable. */
export function daysFromToday(v, now = new Date()) {
  const d = parseDay(v);
  if (!d) return null;
  const a = localToday(now);
  const b = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  return Math.round((b - a) / 86400000);
}
